module.exports = __webpack_public_path__ + "static/media/icon-chevron-right.1fb0de4d.svg";